<ng-container 
    *appLet="{
        featIsOnUS505: gbs.growthBook.isOn(gbf.FEAT_US505_BGCOLOR_CTA_FRONTPAGE_SEARCH),
        featStringValueUS505: gbs.growthBook.getFeatureValue(gbf.FEAT_US505_BGCOLOR_CTA_FRONTPAGE_SEARCH, ''),
    } as $comp">
    <div class="search-footer">
        <div class="search-footer__btn-container">
            <button
              type="submit"
              class="btn btn-primary btn-cta w-100 fw-medium"
              [ngClass]="{
                'btn-cta--variant-b': $comp.featIsOnUS505 && $comp.featStringValueUS505 === 'b',
                'btn-cta--variant-c': $comp.featIsOnUS505 && $comp.featStringValueUS505 === 'c',
                'btn-cta--variant-d': $comp.featIsOnUS505 && $comp.featStringValueUS505 === 'd',
                'btn-cta--variant-e': $comp.featIsOnUS505 && $comp.featStringValueUS505 === 'e',
              }"
              data-qa="search-widget-button-submit"
            >
              {{ cmsCopy.showFlights }}
            </button>
          </div>
          @if (isFlightsPage) {
            <div class="search-footer__btn-container">
                <button
                  type="button"
                  class="btn btn-text-primary w-100 fw-medium"
                  data-qa="search-widget-button-cancel"
                  (click)="cancelClick.emit()"
                >
                  {{ cmsCopy.cancel }}
                </button>
            </div>
          }
    </div>
</ng-container>